import { DSLabeledLink } from 'shared-definitions/types'
import { ApiSluggedLink } from '../types.wp'
import { pLinkMapper, PLinkMapperOpts } from './pLinkMapper'

export function sluggedLinkMapper(input: ApiSluggedLink, opts: PLinkMapperOpts): DSLabeledLink {
  return {
    label: input.name,
    pLink: pLinkMapper(input.slug, opts),
  }
}
